import { IBlock } from './PropsBlock';
import ClassNames from 'classnames';

import styles from './Block.module.scss';

const Block = ({ className, width, height, padding, children, refBlock, onClick, ...other }: IBlock): JSX.Element => {
  return (
    <div ref={refBlock} onClick={onClick} style={{ padding, width, height }} className={ClassNames(styles.Block, className)} {...other}>
      {children}
    </div>
  );
};

export default Block;
